var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch, Model } from "vue-property-decorator";
import { cloneDeep } from "lodash";
import RegexStr from "../../common/RegexStr";
import ImgCropper from './ImgCropper.vue';
import XLSX from 'xlsx';
import isUtf8 from "./isUtf8";
var cptable = require("xlsx/dist/cpexcel.js");
var UploadGood = (function (_super) {
    __extends(UploadGood, _super);
    function UploadGood() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogImageUrl = '';
        _this.dialogVisible = false;
        _this.pdfDialogUrl = '';
        _this.rightWidth = '356px';
        _this.pdfDialogVisible = false;
        _this.excelHtmlVisible = false;
        _this.excelHtml = '';
        _this.fileType = '';
        _this.pdfRegx = new RegExp(RegexStr.pdf);
        _this.excelRegx = new RegExp(RegexStr.excel);
        return _this;
    }
    UploadGood.prototype.fileListWatch = function () {
        this.updateStyle();
    };
    UploadGood.prototype.uploadFinishedWatch = function () {
        this.initStyle();
    };
    UploadGood.prototype.mounted = function () {
        this.initStyle();
        this.handlePlusIconShow();
    };
    UploadGood.prototype.updateStyle = function () {
        if (this.fileList && this.fileList.length) {
            if (this.uploadFinished || this.excelHtmlVisible) {
                this.initStyle();
            }
            else {
                this.defalutStyle();
            }
        }
        this.handlePlusIconShow();
    };
    UploadGood.prototype.defalutStyle = function () {
        var child = document.getElementById('ocr-upload-img');
        var model = document.getElementById('ocr-upload-img-model');
        if (child) {
            child.style.width = '200px';
            child.style.height = '280px';
        }
        if (model) {
            model.style.width = '200px';
            model.style.height = '280px';
        }
    };
    UploadGood.prototype.initStyle = function () {
        var parent = document.getElementById('ocr-content-wrap');
        var child = document.getElementById('ocr-upload-img');
        var model = document.getElementById('ocr-upload-img-model');
        if (parent) {
            parent.style.height = this.uploadFinished ? '600px' : '400px';
        }
        var width = this.uploadFinished ? '356px' : '200px';
        if (child) {
            child.style.width = width;
            child.style.height = (parent.offsetHeight - 110) + 'px';
        }
        if (model) {
            model.style.width = width;
            model.style.height = (parent.offsetHeight - 110) + 'px';
        }
    };
    UploadGood.prototype.handleCrop = function (url, oldUrl) {
        var fileList = cloneDeep(this.fileList);
        var index = fileList.findIndex(function (v) { return v.url == oldUrl; });
        if (index > -1) {
            fileList[index].url = url;
            this.$emit("change", fileList);
        }
    };
    UploadGood.prototype.handleEdit = function (file) {
        console.log('handleEdit>>>', file);
        this.$refs.imgCropper.show(file.url);
    };
    UploadGood.prototype.handlePlusIconShow = function () {
        if (this.$refs.upload) {
            var currentLength = this.fileList.length;
            var displayStatus = currentLength >= this.limit ? "none" : "";
            this.$refs.upload.$children[1].$el.style.display = displayStatus;
        }
    };
    UploadGood.prototype.handleRemove = function (file) {
        var _this = this;
        this.uploadFinished = false;
        this.$emit("remove", file, this.fileList);
        var CALL_BACK = function () {
            var fileList = _this.fileList.filter(function (v) { return v.url != file.url; });
            _this.$emit("change", JSON.parse(JSON.stringify(fileList)));
        };
        if (this.removeConfirmTip) {
            this.$confirm(this.removeConfirmTip).then(function () {
                CALL_BACK();
            }).catch(function () { });
            return;
        }
        CALL_BACK();
    };
    UploadGood.prototype.handlePictureCardPreview = function (file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    };
    UploadGood.prototype.handlePdfPreview = function (file) {
        this.pdfDialogUrl = file.url;
        this.pdfDialogVisible = true;
    };
    UploadGood.prototype.handleExcelPreview = function (file) {
        var url = file.url;
        this.pdfDialogUrl = 'https://view.officeapps.live.com/op/view.aspx?src=' + url;
        this.pdfDialogVisible = true;
    };
    UploadGood.prototype.handleChange = function (file, fileList) {
        var _this = this;
        if (file && file.raw) {
            var name = file.name.split("."), fileType_1 = name[name.length - 1];
            this.fileType = fileType_1;
            if (fileType_1 && (fileType_1 == "xlsx" || fileType_1 == "xls" || fileType_1 == 'csv')) {
                this.excelHtmlVisible = true;
                file.raw.arrayBuffer().then(function (data) {
                    var wb = XLSX.read(data);
                    if (fileType_1 == 'csv') {
                        var buf = new Uint8Array(data);
                        var isUtf8File = isUtf8(buf);
                        wb = XLSX.read(isUtf8File ? data : cptable.utils.decode(936, buf), { type: isUtf8File ? "array" : 'string' });
                    }
                    var ws = wb.Sheets[wb.SheetNames[0]];
                    _this.excelHtml = XLSX.utils.sheet_to_html(ws);
                    console.log('this.excelHtml===', _this.excelHtml);
                });
            }
            else {
                this.excelHtmlVisible = false;
            }
        }
        else {
            this.excelHtmlVisible = false;
        }
    };
    UploadGood.prototype.exceedLimit = function (files, fileList) {
        this.$message({
            showClose: true,
            message: "最多上传" + this.limit + "个文件",
            type: 'error'
        });
    };
    UploadGood.prototype.beforeAvatarUpload = function (file) {
        var isLtMaxSize = file.size / 1024 / 1024 < +this.maxSize;
        if (!isLtMaxSize) {
            this.$message({
                showClose: true,
                message: "单个文件大小不能超过 " + this.maxSize + "MB!",
                type: 'error'
            });
            return false;
        }
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls" || fileType == 'csv' || fileType == 'png' || fileType == 'jpg'))) {
            this.$message({
                showClose: true,
                message: "文件只能是jpg/png/csv/xls",
                type: 'error'
            });
            return false;
        }
        ;
    };
    UploadGood.prototype.checkExcel = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        return fileType && (fileType == 'xlsx' || fileType == 'xls' || fileType == 'csv');
    };
    UploadGood.prototype.uploadSuccess = function (response, file, fileList) {
        var _this = this;
        if (response.success) {
            if (fileList.length) {
                var imageList = fileList;
                imageList.forEach(function (item) {
                    if (item.response) {
                        item.url = item.response.data.full_path;
                        item.file = file.raw;
                        item.isExcel = _this.checkExcel(file.raw);
                    }
                });
                this.$emit("success", imageList);
            }
        }
        else {
            this.$message({
                showClose: true,
                message: response.msg || "上传异常",
                type: 'error'
            });
        }
    };
    UploadGood.prototype.clear = function () {
        this.excelHtml = '';
        this.dialogImageUrl = '';
        this.dialogVisible = false;
    };
    __decorate([
        Prop({
            default: "/supplierapi/upload",
            type: String
        })
    ], UploadGood.prototype, "action", void 0);
    __decorate([
        Prop({
            default: false,
            type: Boolean
        })
    ], UploadGood.prototype, "uploadFinished", void 0);
    __decorate([
        Prop({
            default: false,
            type: Boolean
        })
    ], UploadGood.prototype, "multiple", void 0);
    __decorate([
        Prop({
            default: 1,
            type: Number
        })
    ], UploadGood.prototype, "limit", void 0);
    __decorate([
        Prop({
            default: 5,
            type: Number
        })
    ], UploadGood.prototype, "maxSize", void 0);
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], UploadGood.prototype, "removeConfirmTip", void 0);
    __decorate([
        Model("change", {
            required: true,
            type: Array,
        })
    ], UploadGood.prototype, "fileList", void 0);
    __decorate([
        Watch("fileList")
    ], UploadGood.prototype, "fileListWatch", null);
    __decorate([
        Watch("uploadFinished")
    ], UploadGood.prototype, "uploadFinishedWatch", null);
    UploadGood = __decorate([
        Component({
            components: {
                ImgCropper: ImgCropper
            }
        })
    ], UploadGood);
    return UploadGood;
}(Vue));
export default UploadGood;
